import { Mutation, ActionContext, Getter } from 'vuex'
import {
    SET_FOLDER_NAME_TITLE,
    SET_PRODUCT_LIST,
    SET_PRODUCT_LIST_COUNT,
    SET_SEARCH_PRODUCT_TYPE,
    SET_SHOW_PRODUCT_LIST_FOLDER_ID,
    SET_PAGE_NUMBER,
    SET_CURRENT_PAGE,
} from "../constants/const";

interface ProductState {
    folderNameTitle: string;
    productList: Array<any>;
    productListCount: number,
    searchProductType: string,
    showProductListFolderId: number,
    pageSize: number,
    currentPage: number,
}

interface ProductMutation {
    [mutationType: string]: Mutation<ProductState>;
}

interface ProductActions {
    [actionType: string]: (injectee: ActionContext<ProductState, any>, payload: any) => void;
}

interface ProductGetter {
    [getter: string]: Getter<ProductState, any>;
}

const state: ProductState = {
    folderNameTitle: "",
    productList: [],
    productListCount: 0,
    searchProductType: "",
    showProductListFolderId: -1,
    pageSize: 0,
    currentPage: 0,
}

const mutations: ProductMutation = {
    [SET_FOLDER_NAME_TITLE](state: ProductState, newState: string): void {
        state.folderNameTitle = newState;
    },
    [SET_PRODUCT_LIST](state: ProductState, newState: Array<any>): void {
        state.productList = newState;
    },
    [SET_PRODUCT_LIST_COUNT](state: ProductState, newState: number): void {
        state.productListCount = newState;
    },
    [SET_SEARCH_PRODUCT_TYPE](state: ProductState, newState: string): void {
        state.searchProductType = newState;
    },
    [SET_SHOW_PRODUCT_LIST_FOLDER_ID](state: ProductState, newState: number): void {
        state.showProductListFolderId = newState;
    },
    [SET_PAGE_NUMBER](state: ProductState, newState: number): void {
        state.pageSize = newState;
    },
    [SET_CURRENT_PAGE](state: ProductState, newState: number): void {
        state.currentPage = newState;
    },
}

const actions: ProductActions = {
    [SET_FOLDER_NAME_TITLE](context: ActionContext<ProductState, any>, newTitle: string): void {
        context.commit(SET_FOLDER_NAME_TITLE, newTitle)
    },
    [SET_PRODUCT_LIST](context: ActionContext<ProductState, any>, newList: Array<any>): void {
        context.commit(SET_PRODUCT_LIST, newList)
    },
    [SET_PRODUCT_LIST_COUNT](context: ActionContext<ProductState, any>, newCount: number): void {
        context.commit(SET_PRODUCT_LIST_COUNT, newCount)
    },
    [SET_SEARCH_PRODUCT_TYPE](context: ActionContext<ProductState, any>, newType: string): void {
        context.commit(SET_SEARCH_PRODUCT_TYPE, newType)
    },
    [SET_SHOW_PRODUCT_LIST_FOLDER_ID](context: ActionContext<ProductState, any>, newFolderId: number): void {
        context.commit(SET_SHOW_PRODUCT_LIST_FOLDER_ID, newFolderId)
    },
    [SET_PAGE_NUMBER](context: ActionContext<ProductState, any>, newPageNumber: number): void {
        context.commit(SET_PAGE_NUMBER, newPageNumber)
    },
    [SET_CURRENT_PAGE](context: ActionContext<ProductState, any>, newCurrentPage: number): void {
        context.commit(SET_CURRENT_PAGE, newCurrentPage)
    },
}

const getters: ProductGetter = {
}

export default {
    namespace: true,
    state,
    mutations,
    actions,
    getters
}